import { render, staticRenderFns } from "./WebSiteVideo.vue?vue&type=template&id=d7e7473a&"
import script from "./WebSiteVideo.vue?vue&type=script&lang=js&"
export * from "./WebSiteVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VideoPlayer: require('/Users/eralpsoftwareweb/Desktop/Active Projects/Heocademy/Gökçe Özel/gokce-ozel-nuxt/components/VideoPlayer/Player.vue').default})
